import { render } from "./NewEventForm.vue?vue&type=template&id=4d61a0ba&scoped=true"
import script from "./NewEventForm.vue?vue&type=script&lang=js"
export * from "./NewEventForm.vue?vue&type=script&lang=js"

import "./NewEventForm.vue?vue&type=style&index=0&id=4d61a0ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d61a0ba"]])

export default __exports__